export default class Vehicle {
	constructor({
		id,
		identification,
		profile,
		max_travel_distance,
		max_travel_duration,
		init_depot_id,
		end_depot_id,
		costs,
		additional_info,
		json_properties,
		teams_id,
		breaks_id,
		skills_id,
		capacities,
	}) {
		this.id = id || 0;
		this.identification = identification || "";
		this.profile = profile || "car";
		this.max_travel_distance = max_travel_distance || null;
		this.max_travel_duration = max_travel_duration || null;
		this.init_depot_id = init_depot_id || null;
		this.end_depot_id = end_depot_id || null;
		this.additional_info = additional_info ? additional_info : {};
		this.costs = costs || {
			time: 0,
			traveled_hour: 0,
			distance: 0,
			fixed: 0,
		};
		this.json_properties = json_properties || [];
		this.teams_id = teams_id || [];
		this.breaks_id = breaks_id || [];
		this.skills_id = skills_id || [];
		this.capacities = capacities || [];
	}
}
